import Drawer from 'components/Drawer'
import React from 'react'
import AddConfirm from './Partials'

const ConfirmDrawer = ({
  confirmDrawer,
  setConfirmDrawer,
  file,
  rolesMetrics,
  setSearchParams,
  searchParams,
  handleClose = () => {},
  resultText,
  resultDescription
}) => {
  function isObject(value) {
    return typeof value === 'object' && value !== null
  }
  const onClose = () => {
    setSearchParams({
      ...searchParams,
      isUpload: isObject(rolesMetrics?.extAssmnts),
      stage: rolesMetrics?.roundName,
      type: rolesMetrics?.type ? rolesMetrics?.type : 'all',
      assessment: rolesMetrics?.assesmentType
        ? rolesMetrics?.assesmentType
        : 'Test Gorilla',
      assessmentId: rolesMetrics?.extAssmnts?.id,
    })
    setConfirmDrawer(false)
    handleClose()
  }

  const content = () => {
    return (
      <AddConfirm
        onClose={onClose}
        resultText={resultText}
        resultDescription={resultDescription}
      />
    )
  }

  return (
    <Drawer
      width="40%"
      title={'Bulk Upload'}
      placement="right"
      padding="30px"
      headerpadding="16px 30px"
      closable
      onClose={onClose}
      visible={confirmDrawer}
      content={content()}
    />
  )
}

export default ConfirmDrawer
